/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box, Button, Stack, IconButton, Divider } from "@common-ui/ui";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import _ from "lodash";
// import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import { DataList } from "./DataList";

export function MainDialog(props) {
  const isDisabled = () => {
    if (props.isLoading) {
      return true;
    }
    if (props.data.length !== props.updatedLeft.length) {
      return false;
    }
    const indexLookUp = _.keyBy(props.serverWorkItems, (object) => {
      return object.asset;
    });
    const workItemsToBeRemoved = _.filter(props.updatedLeft, (item) => {
      return item["workItemID"] !== undefined;
    });
    const newWorkItem = _.filter(props.workItems, (asset) => {
      return indexLookUp[asset.system_id] === undefined;
    });
    if (workItemsToBeRemoved.length) {
      return false;
    }
    if (newWorkItem.length) {
      return false;
    }
    return true;
  };
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={() => {
          props.handleClose();
        }}
        aria-labelledby="alert-dialog-name"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        PaperProps={{ sx: { bgcolor: "background.paper" } }}
        // fullWidth={true}
        maxWidth="md"
      >
        <>
          <DialogTitle id="alert-dialog-title" scroll="paper">
            <Stack sx={{ alignItems: "left" }}>
              <Typography variant="h4">
                Add work items to this work event
              </Typography>
            </Stack>
            {props.open ? (
              <IconButton
                aria-label="close"
                onClick={() => {
                  props.handleClose();
                }}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <Divider />
          <DialogContent sx={{background: "#F8F8F8"}}>
            <Box component="main">
              <DataList {...props} />
            </Box>
          </DialogContent>
          <DialogActions>
            <Box sx={{ display: "flex" }}>
              <div>
                <Button
                  sx={{ mr: 2 }}
                  color="primary"
                  // disabled={formik.isSubmitting}
                  // fullWidth
                  size="large"
                  // onClick={() => router.goBack()}
                  onClick={() => {
                    // props.setCustomer(null);
                    props.handleClose();
                  }}
                  // type="submit"
                  variant="text"
                >
                  Cancel
                </Button>
              </div>
              <div>
                <Button
                  color="primary"
                  disabled={isDisabled()}
                  // fullWidth
                  size="large"
                  // type="submit"
                  onClick={() => {
                    props.handleSubmit();
                  }}
                  variant="contained"
                >
                  Save work items
                </Button>
              </div>
            </Box>
          </DialogActions>
        </>
      </Dialog>
    </div>
  );
}
